export { default } from './information';
